import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const sizeClasses = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-[1.7rem]',
    xl: 'text-[2.35rem]',
};
const trackingClasses = {
    sm: 'tracking-[-0.04em]',
    md: 'tracking-[-0.045em]',
    lg: 'tracking-[-0.05em]',
    xl: 'tracking-[-0.055em]',
};
const toneClasses = {
    dark: {
        beacon: {
            snap: 'text-white',
            v: 'text-emerald-300',
            ai: 'text-sky-300',
        },
        prism: {
            snap: 'bg-[linear-gradient(90deg,#ffffff,#bfe1ff)] bg-clip-text text-transparent',
            v: 'text-emerald-300',
            ai: 'text-cyan-200',
        },
        seal: {
            snap: 'text-white',
            v: 'text-emerald-300',
            ai: 'rounded-full border border-sky-300/30 bg-sky-400/10 px-[0.42em] py-[0.08em] text-sky-100',
            wrapper: 'gap-[0.08em]',
        },
    },
    light: {
        beacon: {
            snap: 'text-white',
            v: 'text-emerald-300',
            ai: 'text-sky-300',
        },
        prism: {
            snap: 'bg-[linear-gradient(90deg,#ffffff,#bfe1ff)] bg-clip-text text-transparent',
            v: 'text-emerald-300',
            ai: 'text-cyan-200',
        },
        seal: {
            snap: 'text-white',
            v: 'text-emerald-300',
            ai: 'rounded-full border border-sky-300/30 bg-sky-400/10 px-[0.42em] py-[0.08em] text-sky-100',
            wrapper: 'gap-[0.08em]',
        },
    },
};
export const DEFAULT_BRAND_VARIANT = 'beacon';
export const BrandWordmark = ({ variant = DEFAULT_BRAND_VARIANT, theme = 'dark', size = 'md', className = '', }) => {
    const palette = toneClasses[theme][variant];
    return (_jsxs("span", { className: `inline-flex items-center font-bold ${sizeClasses[size]} ${trackingClasses[size]} ${palette.wrapper || ''} ${className}`.trim(), children: [_jsx("span", { className: palette.snap, children: "SNAP" }), _jsx("span", { className: palette.v, children: "V" }), _jsx("span", { className: palette.ai, children: ".AI" })] }));
};
